const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL !== undefined
    ? process.env.REACT_APP_API_BASE_URL
    : 'http://localhost:5244';
const VISITOR_ID_KEY = 'raadso_visitor_id';

const SERVICE_LABELS = {
  branding: 'Branding Services',
  'mobile-app': 'Mobile App Development',
  'web-development': 'Web Development',
  'web-hosting': 'Web Hosting',
  marketing: 'Digital Marketing',
  'data-analysis': 'Data Analysis',
};

export function getVisitorId() {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }
  return visitorId;
}

export function getPageMeta(pathname, hash = '') {
  if (pathname === '/') {
    const sectionMap = {
      '#home': 'Home',
      '#about': 'About',
      '#services': 'Services',
      '#portfolio': 'Portfolio',
      '#contact': 'Contact',
    };
    const section = sectionMap[hash] || 'Home';
    return {
      pagePath: hash ? `/${hash}` : '/',
      pageLabel: section,
      serviceSlug: null,
      serviceCategory: null,
    };
  }

  if (pathname.startsWith('/services/')) {
    const slug = pathname.split('/')[2] || '';
    return {
      pagePath: pathname,
      pageLabel: SERVICE_LABELS[slug] || slug.replace(/-/g, ' '),
      serviceSlug: slug,
      serviceCategory: 'Services',
    };
  }

  if (pathname.startsWith('/portfolio/')) {
    const slug = pathname.split('/')[2] || '';
    return {
      pagePath: pathname,
      pageLabel: slug.replace(/-/g, ' '),
      serviceSlug: null,
      serviceCategory: 'Portfolio',
    };
  }

  if (pathname.startsWith('/admin')) {
    const adminLabels = {
      '/admin/login': 'Admin Login',
      '/admin': 'Admin Dashboard',
      '/admin/dashboard': 'Admin Dashboard',
    };

    if (adminLabels[pathname]) {
      return {
        pagePath: pathname,
        pageLabel: adminLabels[pathname],
        serviceSlug: null,
        serviceCategory: null,
      };
    }

    if (pathname.startsWith('/admin/modules/')) {
      const module = pathname.split('/')[3] || 'module';
      return {
        pagePath: pathname,
        pageLabel: module.replace(/-/g, ' '),
        serviceSlug: null,
        serviceCategory: 'Admin',
      };
    }
  }

  return {
    pagePath: pathname,
    pageLabel: pathname,
    serviceSlug: null,
    serviceCategory: null,
  };
}

export async function trackVisit({ pagePath, pageLabel, serviceSlug, serviceCategory, durationSeconds = 0 }) {
  try {
    await fetch(`${API_BASE_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        visitorId: getVisitorId(),
        pagePath,
        pageLabel,
        serviceSlug,
        serviceCategory,
        durationSeconds,
      }),
      keepalive: true,
    });
  } catch {
    // Ignore tracking failures on the public site.
  }
}
